export const WORKFLOW_DND_MIME = 'application/x-segmailer-workflow-node';

export type WorkflowPaletteItem = {
  nodeType: string;
  config: {
    name: string;
    description: string;
    icon: string;
    color: string;
  };
};

export type WorkflowPaletteDropPayload = WorkflowPaletteItem & {
  source: 'right-panel';
  createdAt: number;
};

export const buildWorkflowPalettePayload = (
  item: WorkflowPaletteItem
): WorkflowPaletteDropPayload => ({
  ...item,
  source: 'right-panel',
  createdAt: Date.now(),
});
